import {
  PriceCalculatorResultV2Query,
  PriceCalculatorResultV2QueryVariables,
} from "@/gql/graphql";
import { gql, useLazyQuery } from "@apollo/client";
import { fetchPriceCalculatorFragment } from "../gql/fragments";
import { CustomerResultData, PriceCalculatorFormData } from "../types/types";
import { transformToCustomerSectionalResultData } from "../lib/transformers";

/**
 * Pass the customer arguments to have the result stored as the current
 * customer result. The booking flow calls this without them and keeps the
 * returned data instead.
 */
export const usePriceCalculation = (
  formData?: PriceCalculatorFormData,
  setCustomerCalculatedState?: React.Dispatch<
    React.SetStateAction<PriceCalculatorFormData>
  >,
  setCustomerResult?: React.Dispatch<
    React.SetStateAction<CustomerResultData | undefined>
  >
) => {
  //FIXME: Rename when old price calculator is removed
  const query = gql`
    ${fetchPriceCalculatorFragment}
    query PriceCalculatorResultV2($input: PriceCalculatorInput!) {
      priceCalculator {
        byInput(variables: $input) {
          __typename
          ... on PriceCalculatorError {
            error
            errorType
          }
          ...FetchPriceCalculator
        }
      }
    }
  `;
  const [calculatePrice, { loading, data, error }] = useLazyQuery<
    PriceCalculatorResultV2Query,
    PriceCalculatorResultV2QueryVariables
  >(query, {
    fetchPolicy: "network-only",
    onCompleted: (data) => {
      if (formData && setCustomerCalculatedState && setCustomerResult) {
        setCustomerCalculatedState(formData);
        setCustomerResult(transformToCustomerSectionalResultData(data));
      }
    },
  });

  return {
    calculatePrice,
    loading,
    data,
    error,
  };
};
